import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { EERIE } from 'HubStyleTokens/colors';
import SelectionPanelButton from 'automation-ui-canvas/create/SelectionPanelButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function SelectionPanelOptionButton({
  option: {
    text,
    indicator,
    locked,
    icon,
    disabled,
    tooltip,
    help
  },
  onClick
}) {
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    disabled: !tooltip,
    children: /*#__PURE__*/_jsx(SelectionPanelButton, {
      onClick: onClick,
      disabled: disabled,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "baseline",
          gap: "100",
          children: [icon && /*#__PURE__*/_jsx(UIIcon, {
            name: icon,
            className: "m-right-2",
            color: disabled ? undefined : EERIE
          }), indicator !== null && indicator !== void 0 ? indicator : text, locked && /*#__PURE__*/_jsx(UIIcon, {
            name: "locked",
            color: EERIE
          })]
        }), help && /*#__PURE__*/_jsx(Text, {
          typography: "detail-200",
          color: disabled ? 'text-primary-disabled' : 'text-core-subtle',
          children: help
        })]
      })
    })
  });
}